import ResetPasswordForm from '@src/features/tenant/auth/ResetPasswordForm';
import TenantCenterCardLayout from '@src/layouts/tenant/TenantCenterCardLayout';

function TenantResetPassword() {
  return (
    <>
      <TenantCenterCardLayout>
        <ResetPasswordForm />
      </TenantCenterCardLayout>
    </>
  );
}

export default TenantResetPassword;
